<script>
import dom from '../../mixins/dom';

export default {
    name: 'DsBodyClickHandler',

    mixins: [dom],

    props: {
        target: HTMLElement,
        enabled: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        if (this.enabled) {
            this.addEventListener();
        }
    },

    beforeDestroy() {
        this.removeEventListener();
    },

    watch: {
        enabled(enabled) {
            if (enabled) {
                this.addEventListener();
            } else {
                this.removeEventListener();
            }
        },
    },

    methods: {
        addEventListener() {
            setTimeout(() => {
                window.addEventListener('click', this.handleClick);

                if (this.dom_isTouchDevice) {
                    window.addEventListener('touchend', this.handleClick);
                }
            });
        },

        removeEventListener() {
            setTimeout(() => {
                window.removeEventListener('click', this.handleClick);

                if (this.dom_isTouchDevice) {
                    window.removeEventListener('touchend', this.handleClick);
                }
            });
        },

        handleClick(e) {
            const target = this.target || this.$el;

            if (!this.dom_clickedTarget(e, target)) {
                this.$emit('click', e);
            }
        },
    },

    render() {
        return this.$slots.default;
    },
};
</script>
